import type { CartUI } from '@libs/common-node';
import type { Nullable } from '@libs/core';

export const canProductProceed = (cartIDCookie: string | undefined, cart: Nullable<CartUI>) => {
    if (!cartIDCookie) {
        return true;
    }
    return Boolean(cart?.id && cart?.version);
};
